// A ChunkLoadError is raised when a lazily-imported bundle fails to download —
// almost always because a new deployment rotated the hashed chunk filenames while
// the tab is still holding a stale asset manifest, or because of a flaky/slow
// network. Route screens (lazyScreen) surface this through the navigation error
// screen; nested components (lazyComponent) render their own error fallback.
export function isChunkLoadError(error) {
    if (!error) {
        return false;
    }

    if (error.name === 'ChunkLoadError') {
        return true;
    }

    const message = typeof error === 'string' ? error : error.message;
    return typeof message === 'string' && /Loading( CSS)? chunk \S+ failed/.test(message);
}

// Any failure to bring in a lazily-loaded component: a missing/timed-out chunk
// (ChunkLoadError) or Vue's defineAsyncComponent hitting its `timeout` on a slow
// network. Both are network/deploy artifacts, not actionable bugs, so they are
// kept out of error reporting (see FrameworkConfig).
export function isLazyLoadError(error) {
    if (isChunkLoadError(error)) {
        return true;
    }

    const message = error && (typeof error === 'string' ? error : error.message);
    return typeof message === 'string' && /Async component timed out/.test(message);
}
